import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLoadingBar: false,
    showFondosBar: false,
    selectedFondo: 'GRIDX',
  },
  mutations: {
    toggleLoadingBar(state, value) {
      state.showLoadingBar = value;
    },
    toggleFondosBar(state, value) {
      state.showFondosBar = value;
    },
    selectFondo(state, value) {
      state.selectedFondo = value;
    },
  },
  actions: {
  },
  modules: {
  },
});
